import { ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { ProgressBar, Spinner } from "react-bootstrap";
import { MIBIcon } from "src/componentsUtils/MIBIcon";




export function InfoMessageModal(props: { message?, onDismiss }) {

   if (!props.message) {
      return null
   }

   return (
      <AdvancedDragModal
         PosDefault={{ left: "50%", top: "150px", "transform": "translateX(-50%)" }}
         title={<><MIBIcon icon="info" style={{ marginRight: "1ex" }} />Info</>}
         variant={["Info", "NoMinHeight"]}
         onClose={props.onDismiss}
      >
         <ADModalInfo>
            <div
               dangerouslySetInnerHTML={{ __html: props.message || "" }}
               style={{
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.5"
               }}
            />
         </ADModalInfo>
         <div style={{ height: "15px" }}></div>
      </AdvancedDragModal>
   )
}

export function ErrorMessageModal(props: { message, onDismiss }) {

   if (!props.message) {
      return null
   }


   return (
      <AdvancedDragModal
         PosDefault={{ left: "50%", top: "150px", "transform": "translateX(-50%)" }}
         title={<><MIBIcon icon="error" style={{ marginRight: "1ex" }} />Error</>}
         variant={["Info", "NoMinHeight"]}
         onClose={props.onDismiss}
      >
         <ADModalInfo>
            {props.message}
         </ADModalInfo>
         <div style={{ height: "15px" }}></div>
      </AdvancedDragModal>
   )
}

export function LoadingScreen(props: { message?, percentComplete }) {

   if (!props.message) {
      return null
   }

   return (
      <AdvancedDragModal
         PosDefault={{ left: "50%", top: "150px", "transform": "translateX(-50%)", width: "max(30%,200px)" }}
         variant={["Info", "NoMinHeight"]}
         title={"Loading"}
      >
         <ADModalInfo>
            {props.message}
         </ADModalInfo>
         {props.percentComplete > 0 ?
            (<ProgressBar animated={true} now={props.percentComplete} style={{ borderRadius: "0px" }} />)
            :
            (<center style={{ marginTop: "12px" }}><Spinner size="sm" animation="border" variant="success" /></center>)
         }
         <div style={{ height: "15px" }}></div>
      </AdvancedDragModal>
   )


}